/**
 * DatePicker Component
 * Reusable date picker with validation for 30-day window
 */

import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { isPastDate, isBeyondMaxDays, getValidDateRange } from '../../utils/dateUtils';

const DatePicker = ({
  value,
  onChange,
  label = "Select Date",
  highlightedDates = [],
  disabled = false,
  ...props
}) => {
  const { minDate, maxDate } = getValidDateRange();

  const shouldDisableDate = (date) => {
    return isPastDate(date) || isBeyondMaxDays(date);
  };

  const handleChange = (newValue) => {
    console.log('[DatePicker] Date selected:', newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  // Note: isHighlighted functionality can be added in future with Badge or styling

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MUIDatePicker
        label={label}
        value={value}
        onChange={handleChange}
        shouldDisableDate={shouldDisableDate}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            helperText="Select a date within the next 30 days"
          />
        )}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
